import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary, grayIconFill, midGrey } from '../../../../styles/colors';
import { shadow } from '../../../../styles/shadows';

export const styleSheet = StyleSheet.create({
	clipboardIcon: {
		height: 12,
		marginRight: 6,
		width: 12,
	},
	container: {
		backgroundColor: THEME.colors.background.light,
		boxShadow: shadow,
		boxSizing: 'border-box',
		padding: 24,
		position: 'relative',
		borderRadius: 8,
	},
	header: {
		color: brandPrimary,
		margin: 0,
		marginRight: 24,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	teamType: {
		color: grayIconFill,
		fontSize: 13,
		marginTop: 6,
	},
	memberCount: {
		color: midGrey,
		fontSize: 13,
		marginTop: 4,
	},
	copyButtonContainer: {
		marginTop: 16,
	},
	moreMenu: {
		position: 'absolute',
		right: 16,
		top: 10,
	},
});
